import React, { useState, useEffect } from "react";
import "./ModalPagos.css"; // reutiliza EXACTO el mismo css
import { authFetch } from "../utils/authFetch";

export default function ModalPagosWifi({ cliente, onClose }) {
  const [year, setYear] = useState(new Date().getFullYear());
  const [pagos, setPagos] = useState([]);

  const sinCliente = !cliente;

  useEffect(() => {
    if (!cliente) return;

    authFetch(`/api/pagos/cliente-wifi/${cliente.id}/${year}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.ok && Array.isArray(data.pagos)) setPagos(data.pagos);
        else setPagos([]);
      })
      .catch(() => setPagos([]));
  }, [cliente, year]);

  if (sinCliente) return null;

  const meses = ["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"];
  const nombreCompleto = `${cliente.nombre || ""} ${cliente.apellidos || ""}`.trim();

  function estaPagado(mes) {
    return pagos.some((p) => Number(p.mes) === mes && Number(p.anio) === year);
  }

  return (
    <div className="mp-overlay">
      <div className="mp-card">
        <div className="mp-header">
          <h3>Pagos WiFi de {nombreCompleto}</h3>
          <button className="mp-close" onClick={onClose}>×</button>
        </div>

        <div className="mp-year-select">
          <button onClick={() => setYear(year - 1)}>◀</button>
          <span>{year}</span>
          <button onClick={() => setYear(year + 1)}>▶</button>
        </div>

        <div className="mp-grid-wrapper">
          <div className="mp-grid">
            {meses.map((m, i) => {
              const pagado = estaPagado(i + 1);
              return (
                <div key={i} className={`mp-mes ${pagado ? "pagado" : "nopago"}`}>
                  <span className="mp-mes-label">{m}</span>
                  <div className="mp-status">{pagado ? "✔" : "×"}</div>
                </div>
              );
            })}
          </div>
        </div>

      </div>
    </div>
  );
}
